/*
 * Login Page Messages
 *
 * This contains all the text for the Two Factor Auth Page component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'TwoFactorAuthPage.title',
    defaultMessage: 'Two Factor Authentication',
  },
  submit: {
    id: 'TwoFactorAuthPage.submit',
    defaultMessage: 'Confirm Code',
  },
  requestNewOTP: {
    id: 'TwoFactorAuthPage.requestNewOTP',
    defaultMessage: 'Request New Code',
  },
  enterCode: {
    id: 'TwoFactorAuthPage.enterCode',
    defaultMessage: "Please enter the code we've sent you via SMS",
  },
  tooManyAttempts: {
    id: 'TwoFactorAuthPage.tooManyAttempts',
    defaultMessage:
      'Too many attempts. For security purposes we have lock your access to this transcript. To unlock, please contact your account manager to confirm your identity.',
  },
});



// WEBPACK FOOTER //
// ./components/pages/TwoFactorAuthPage/messages.js